var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"noResult"}},[_c('i',{staticClass:"el-icon-document-delete"}),_c('div',[_vm._v(" "+_vm._s(_vm.$t('result.noResult'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }